import { API, generic } from "api";

export default class DoubtsService {
  static index = async ({ pageState }) => {
    await generic({
      pageState,
      stateApiStatusKey: "API_DOUBTS_INDEX_STATUS",
      stateDataKey: ["doubts"],
      stateErrorKey: ["doubtsErrors"],
      apiEndpoint: API.teachers.doubts.index,
      apiUrlReplacements: {},
      apiData: {},
      errorMessage: "Doubts could not be fetched",
    });
  };

  static show = async ({ pageState, doubtId }) => {
    await generic({
      pageState,
      stateApiStatusKey: "API_DOUBTS_SHOW_STATUS",
      stateDataKey: ["doubt", "user"],
      stateErrorKey: ["doubtErrors", "userErrors"],
      apiEndpoint: API.teachers.doubts.show,
      apiUrlReplacements: { doubtId },
      apiData: {},
      errorMessage: "Doubt could not be fetched",
    });
  };

  static create = async ({ pageState, values }) => {
    await generic({
      pageState,
      stateApiStatusKey: "API_DOUBTS_CREATE_STATUS",
      stateDataKey: ["doubt"],
      stateErrorKey: ["doubtErrors"],
      apiEndpoint: API.teachers.doubts.create,
      apiUrlReplacements: {},
      apiData: { ...values },
      errorMessage: "Payment details could not be fetched",
    });
  };

  static pick = async ({ pageState, doubtId }) => {
    await generic({
      pageState,
      stateApiStatusKey: "API_DOUBTS_PICK_STATUS",
      stateDataKey: ["doubt", "user"],
      stateErrorKey: ["doubtErrors", "userErrors"],
      apiEndpoint: API.teachers.doubts.pick,
      apiUrlReplacements: { doubtId },
      apiData: {},
      errorMessage: "Couldn't pick this doubt",
    });
  };
}
